export const background = '#efefef'
export const backgroundSecondary = '#f7f7f7'
export const black400 = '#333333'
export const black600 = '#0000000d'
export const white = '#ffffff'

export const megaColor = '#6cefa3'
export const quinaColor = '#8667ef'
export const lotoFacilColor = '#DD7AC6'
export const lotoManiaColor = '#ffab66'
export const timeColor = '#5AAD7D'
export const sorteColor = '#BFAF83'
